// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.api-health-container {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
        "Droid Sans", "Helvetica Neue", sans-serif;
    max-width: 100%;
    overflow-x: auto;
}

.api-health-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;
    gap: 20px;
}

.header-content h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 4px;
}

.header-description {
    margin: 0;
    font-size: 14px;
    color: #6b7280;
}

.filter-buttons {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

.filter-btn {
    padding: 8px 16px;
    border: 1px solid #d1d5db;
    background: #ffffff;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s;
}

.filter-btn:hover {
    border-color: #2563eb;
    color: #2563eb;
}

.filter-btn.active {
    background: #2563eb;
    border-color: #2563eb;
    color: #ffffff;
}

.services-grid {
    position: relative;
    margin-bottom: 24px;
}

.services-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.service-row {
    display: flex;
    align-items: center;
    gap: 16px;
    min-height: 48px;
}

.service-name {
    min-width: 120px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #374151;
    font-weight: 500;
}

.child-name {
    font-weight: 400;
    color: #6b7280;
    padding-left: 24px;
}

.expand-btn {
    width: 20px;
    height: 20px;
    border: 1px solid #d1d5db;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 16px;
    color: #6b7280;
    padding: 0;
    line-height: 1;
}

.expand-btn:hover {
    border-color: #9ca3af;
    background: #f9fafb;
}

.blocks-container {
    display: flex;
    gap: 4px;
    flex: 1 1;
}

.status-block {
    /* width: 16px;
    height: 32px; */
    width: 25px;
    height: 43px;
    border-radius: 4px;
    transition: transform 0.2s;
    cursor: pointer;
}

.status-block:hover {
    transform: scale(1.1);
}

.status-block.up {
    background: #10b981;
}

.status-block.degraded {
    background: #86efac;
}

.status-block.down {
    background: #ef4444;
}

.time-axis {
    display: grid;
    grid-template-columns: repeat(24, 1fr);
    /* Updated from 12 to 24 columns to show labels every 2 hours */
    margin-top: 8px;
    margin-left: 136px;
    margin-right: 0;
    position: relative;
    /* width: calc(48 * 16px + 47 * 4px); */
    width: calc(48 * 25px + 47 * 4px);
}

.time-label {
    font-size: 11px;
    color: #6b7280;
    text-align: left;
    position: relative;
}

.date-labels {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    margin-left: 136px;
    font-size: 12px;
    color: #9ca3af;
    font-weight: 500;
}

.legend {
    display: flex;
    justify-content: center;
    gap: 24px;
    padding-top: 16px;
    border-top: 1px solid #e5e7eb;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #6b7280;
}

.legend-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.legend-dot.uptime {
    background: #10b981;
}

.legend-dot.downtime {
    background: #ef4444;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .api-health-header {
        flex-direction: column;
    }

    .filter-buttons {
        width: 100%;
    }

    .filter-btn {
        flex: 1 1;
    }

    .service-name {
        min-width: 80px;
        font-size: 12px;
    }

    .status-block {
        width: 12px;
        height: 24px;
    }

    .time-axis {
        margin-left: 96px;
        width: calc(48 * 12px + 47 * 4px);
    }

    .date-labels {
        margin-left: 96px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/HealthAnalytic/HealthChart.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb;kDAC8C;IAC9C,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,cAAc;IACd,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,SAAO;AACX;;AAEA;IACI;mBACe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,+DAA+D;IAC/D,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,uCAAuC;IACvC,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,iCAAiC;IACrC;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".api-health-container {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 24px;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\",\n        \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n    max-width: 100%;\n    overflow-x: auto;\n}\n\n.api-health-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 32px;\n    gap: 20px;\n}\n\n.header-content h2 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #111827;\n    margin-bottom: 4px;\n}\n\n.header-description {\n    margin: 0;\n    font-size: 14px;\n    color: #6b7280;\n}\n\n.filter-buttons {\n    display: flex;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.filter-btn {\n    padding: 8px 16px;\n    border: 1px solid #d1d5db;\n    background: #ffffff;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #374151;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.filter-btn:hover {\n    border-color: #2563eb;\n    color: #2563eb;\n}\n\n.filter-btn.active {\n    background: #2563eb;\n    border-color: #2563eb;\n    color: #ffffff;\n}\n\n.services-grid {\n    position: relative;\n    margin-bottom: 24px;\n}\n\n.services-list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.service-row {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    min-height: 48px;\n}\n\n.service-name {\n    min-width: 120px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: #374151;\n    font-weight: 500;\n}\n\n.child-name {\n    font-weight: 400;\n    color: #6b7280;\n    padding-left: 24px;\n}\n\n.expand-btn {\n    width: 20px;\n    height: 20px;\n    border: 1px solid #d1d5db;\n    background: #ffffff;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 16px;\n    color: #6b7280;\n    padding: 0;\n    line-height: 1;\n}\n\n.expand-btn:hover {\n    border-color: #9ca3af;\n    background: #f9fafb;\n}\n\n.blocks-container {\n    display: flex;\n    gap: 4px;\n    flex: 1;\n}\n\n.status-block {\n    /* width: 16px;\n    height: 32px; */\n    width: 25px;\n    height: 43px;\n    border-radius: 4px;\n    transition: transform 0.2s;\n    cursor: pointer;\n}\n\n.status-block:hover {\n    transform: scale(1.1);\n}\n\n.status-block.up {\n    background: #10b981;\n}\n\n.status-block.degraded {\n    background: #86efac;\n}\n\n.status-block.down {\n    background: #ef4444;\n}\n\n.time-axis {\n    display: grid;\n    grid-template-columns: repeat(24, 1fr);\n    /* Updated from 12 to 24 columns to show labels every 2 hours */\n    margin-top: 8px;\n    margin-left: 136px;\n    margin-right: 0;\n    position: relative;\n    /* width: calc(48 * 16px + 47 * 4px); */\n    width: calc(48 * 25px + 47 * 4px);\n}\n\n.time-label {\n    font-size: 11px;\n    color: #6b7280;\n    text-align: left;\n    position: relative;\n}\n\n.date-labels {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 4px;\n    margin-left: 136px;\n    font-size: 12px;\n    color: #9ca3af;\n    font-weight: 500;\n}\n\n.legend {\n    display: flex;\n    justify-content: center;\n    gap: 24px;\n    padding-top: 16px;\n    border-top: 1px solid #e5e7eb;\n}\n\n.legend-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: #6b7280;\n}\n\n.legend-dot {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n}\n\n.legend-dot.uptime {\n    background: #10b981;\n}\n\n.legend-dot.downtime {\n    background: #ef4444;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .api-health-header {\n        flex-direction: column;\n    }\n\n    .filter-buttons {\n        width: 100%;\n    }\n\n    .filter-btn {\n        flex: 1;\n    }\n\n    .service-name {\n        min-width: 80px;\n        font-size: 12px;\n    }\n\n    .status-block {\n        width: 12px;\n        height: 24px;\n    }\n\n    .time-axis {\n        margin-left: 96px;\n        width: calc(48 * 12px + 47 * 4px);\n    }\n\n    .date-labels {\n        margin-left: 96px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
